/**
 * Moneda del sitio: pesos argentinos (Mercado Pago / catálogo).
 */
export const DEFAULT_CURRENCY = 'ARS';

export function formatARS(amount) {
  const n = Number(amount);
  if (Number.isNaN(n)) return '—';
  return new Intl.NumberFormat('es-AR', {
    style: 'currency',
    currency: 'ARS',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(n);
}
